/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//const screenRolesPermissions = JSON.parse(localStorage.getItem('ScreenRolesPermissions')) || [];
const checkPermission = (pageName) => {
  const screenRolesPermissions = JSON.parse(localStorage.getItem('ScreenRolesPermissions')) || [];
  
  // Ensure Page and Page.Name are not null or undefined
  return screenRolesPermissions.some(permission => 
    permission.Page && permission.Page.Name === pageName
  );
};
// const checkPermissionCategory = (Cat) => {
//   debugger;
//   var x=screenRolesPermissions.some(permission => permission.Page.PageCategory.Name === Cat);
//   return x;
// };
export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
   // show: JSON.parse(localStorage.getItem("userInfo")).UserType == "Admin",
   // show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin",
   show:true,
   i18n: "Home"
  },
  {
    url: "PushAllNotification",
    name: "PushAllNotification",
    slug: "PushAllNotification",
    icon: "HomeIcon",
   // show: JSON.parse(localStorage.getItem("userInfo")).UserType == "Admin",
   // show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin",
    show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("PushAllNotification"),
   i18n: "PushAllNotification"
  },
  {
    url: "/UsersManagement",
    name: "UsersManagement",
    slug: "UsersManagement",
    icon: "UserIcon",
    //show: JSON.parse(localStorage.getItem("userInfo")).UserType == "Admin",
    show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin" ||(JSON.parse(localStorage.getItem("userInfo")).UserType == "Admin"),
    i18n: "UsersManagement",
    submenu: [
      {
       url:"/UsersManagement/Users",
        name: "Users",
        slug: "Users",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("Users"),
        i18n: "Users"
      },
       {
        url:"/UsersManagement/RealEstateContributions",
         name: "RealEstateContributions",
         slug: "RealEstateContributions",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("RealEstateContributions"),
         i18n: "RealEstateContributions"
       },
       {
         url:"/UsersManagement/SpecialRequests",
          name: "SpecialRequests",
          slug: "SpecialRequests",
          show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("SpecialRequests"),
          i18n: "SpecialRequests"
        },
      ]
  },
  
  {
  url: "/CustomerProperty",
  name: "CustomerProperty",
  slug: "CustomerProperty",
  icon: "GridIcon",
  // Determine visibility based on both UserType and permissions
  show: true,
  i18n: "CustomerProperty",
  submenu: [
    {
      url: "/CustomerProperty/ShowProperty",
      name: "ShowProperty",
      slug: "ShowProperty",
      // Determine submenu visibility based on permissions
      show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("ShowProperty"),
      i18n: "ShowProperty"
    },
  ]
  },
  {
    url: "/ServiceRequests",
    name: "ServiceRequests",
    slug: "ServiceRequests",
    icon: "FileTextIcon",
    show: true,
    i18n: "ServiceRequests",
    submenu: [
      {
       url:"/ServiceRequests/OffersAccepted",
        name: "OffersAccepted",
        slug: "OffersAccepted",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("OffersAccepted"),

        i18n: "OffersAccepted"
      },
      {
        url:"/ServiceRequests/OffersNotAccepted",
         name: "OffersNotAccepted",
         slug: "OffersNotAccepted",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("OffersNotAccepted"),

         i18n: "OffersNotAccepted"
       },
      {
        url:"/ServiceRequests/ServiceRequests",
         name: "ServiceRequests",
         slug: "ServiceRequests",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("ServiceRequests"),

         i18n: "_ServiceRequests"
       },
       
     
    
      ]
  },
  {
    url: "/BankTransfers",
    name: "BankTransfers",
    slug: "BankTransfers",
    icon: "FileTextIcon",
    show: true,
    i18n: "BankTransfers",
    submenu: [
      {
       url:"/BankTransfers/BrokerBankTransfers",
        name: "BrokerBankTransfers",
        slug: "BrokerBankTransfers",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("BrokerBankTransfers"),

        i18n: "BrokerBankTransfers"
      },
      {
        url:"/BankTransfers/ServiceProviderBankTransfers",
         name: "ServiceProviderBankTransfers",
         slug: "ServiceProviderBankTransfers",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("ServiceProviderBankTransfers"),
 
         i18n: "ServiceProviderBankTransfers"
       }
      ]
  },
  {
    url: "/PackagesAndSubscriptions",
    name: "PackagesAndSubscriptions",
    slug: "PackagesAndSubscriptions",
    icon: "FileTextIcon",
    show: true,
    i18n: "PackagesAndSubscriptions",
    submenu: [
      {
       url:"/PackagesAndSubscriptions/BrokerPackage",
        name: "BrokerPackage",
        slug: "BrokerPackage",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("BrokerPackage"),

        i18n: "BrokerPackage"
      },
      {
        url:"/PackagesAndSubscriptions/ServiceProviderSubscription",
         name: "ServiceProviderSubscription",
         slug: "ServiceProviderSubscription",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("ServiceProviderSubscription"),

         i18n: "ServiceProviderSubscription"
       },
     
     
    
      ]
  },
   {
    url: "/complaintSuggestions",
    name: "Complaint Suggestions",
    slug: "RaqmanaComplaintSuggestions",
    icon: "MessageSquareIcon",
    i18n: "ComplaintSuggestions",
    show: true
  },
  {
    url: "/Setting",
    name: "Setting",
    slug: "Setting",
    icon: "SettingsIcon",
    show: true,
    i18n: "Setting",
    submenu: [
      
      {
        url:"/Settings/Country",
         name: "Country",
         slug: "Country",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("Country"),

         i18n: "Country",
       
       },
      //  {
      //   url:"/Settings/Privacy",
      //    name: "Privacy",
      //    slug: "Privacy",
      //    show: true,
      //    i18n: "Privacy",
       
      //  },
       {
        url:"/Settings/City",
         name: "City",
         slug: "City",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("City"),

         i18n: "City",
       
       },
       {
        url:"/Settings/Nationality",
         name: "Nationality",
         slug: "Nationality",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("Nationality"),

         i18n: "Nationality",
       
       },
      //  {
      //   url:"/Settings/Region",
      //    name: "Region",
      //    slug: "Region",
      //    show: true,
      //    i18n: "Region",
       
      //  },
       
       {
        url:"/Settings/RealEstateServicesManagement/ServicesManagement",
         name: "ServicesManagement",
         slug: "ServicesManagement",
         show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("ServicesManagement"),
         i18n: "ServicesManagement"
       },
       {
         url:"/Settings/RealEstateServicesManagement/ServiceTypeManagement",
          name: "ServiceTypeManagement",
          slug: "ServiceTypeManagement",
          show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("ServiceTypeManagement"),

          i18n: "ServiceTypeManagement"
        },
        {
          url:"/Settings/Subscriptions/Packages",
           name: "Packages",
           slug: "Packages",
           show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("Packages"),

           i18n: "Packages"
         },
         {
           url:"/Settings/Subscriptions/SubscriptionPeriod",
            name: "SubscriptionPeriod",
            slug: "SubscriptionPeriod",
            show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("SubscriptionPeriod"),

            i18n: "SubscriptionPeriod"
          },
          {
            url:"/Settings/PropertyCatgeory",
             name: "PropertyCatgeory",
             slug: "PropertyCatgeory",
             show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("PropertyCatgeory"),

             i18n: "PropertyCatgeory"
           },
           {
            url:"/Settings/MobileSliders/MobileSliders",
             name: "MobileSliders",
             slug: "MobileSliders",
             show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("MobileSliders"),

             i18n: "MobileSliders"
           },
    ]
  },
  {
    url: "/TermsAndConditions",
    name: "TermsAndConditions",
    slug: "TermsAndConditions",
    icon: "FileTextIcon",
    show: true,
    i18n: "TermsAndConditions",
    submenu: [
      {
       url:"/TermsAndConditions/TermsAndCondition",
        name: "TermsAndCondition",
        slug: "TermsAndCondition",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("TermsAndConditions"),

        i18n: "TermsAndCondition"
      },
      
     
    
      ]
  },
  {
    url: "/BannerAds",
    name: "BannerAds",
    slug: "BannerAds",
    icon: "FileTextIcon",
    show: true,
    i18n: "BannerAds",
    submenu: [
      {
       url:"/BannerAds/BannerAds",
        name: "BannerAds",
        slug: "BannerAds",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("BannerAds"),

        i18n: "BannerAds"
      },
      
     
    
      ]
  },
  {
    url: "/Reports",
    name: "Reports",
    slug: "Reports",
    icon: "PrinterIcon",
    show: true,
    i18n: "Reports",
    submenu: [
      {
       url:"/Reports/BrokerReport",
        name: "BrokerReport",
        slug: "BrokerReport",
        show: true,
        i18n: "BrokerReport"
      },
      {
        url:"/Reports/ServiceProviderReport",
         name: "ServiceProviderReport",
         slug: "ServiceProviderReport",
         show: true,
         i18n: "ServiceProviderReport"
       },
       {
        url:"/Reports/CustomerReport",
         name: "CustomerReport",
         slug: "CustomerReport",
         show: true,
         i18n: "CustomerReport"
       },
       {
        url:"/Reports/EmployeeReport",
         name: "EmployeeReport",
         slug: "EmployeeReport",
         show: true,
         i18n: "EmployeeReport"
       },
       {
        url:"/Reports/CustomerPropertyReport",
         name: "CustomerPropertyReport",
         slug: "CustomerPropertyReport",
         show: true,
         i18n: "CustomerPropertyReport"
       },
       {
        url:"/Reports/AcceptedOffersReport",
         name: "AcceptedOffersReport",
         slug: "AcceptedOffersReport",
         show: true,
         i18n: "AcceptedOffersReport"
       },
       {
        url:"/Reports/NotAcceptedOffersReport",
         name: "NotAcceptedOffersReport",
         slug: "NotAcceptedOffersReport",
         show: true,
         i18n: "NotAcceptedOffersReport"
       },
       {
        url:"/Reports/BrokerSubscriptionReport",
         name: "BrokerSubscriptionReport",
         slug: "BrokerSubscriptionReport",
         show: true,
         i18n: "BrokerSubscriptionReport"
       },
       {
        url:"/Reports/ServiceProviderSubscriptionReport",
         name: "ServiceProviderSubscriptionReport",
         slug: "ServiceProviderSubscriptionReport",
         show: true,
         i18n: "ServiceProviderSubscriptionsReport"
       },
       {
        url:"/Reports/BrokersBankTransferReport",
         name: "BrokersBankTransferReport",
         slug: "BrokersBankTransferReport",
         show: true,
         i18n: "BrokersBankTransferReport"
       },
       {
        url:"/Reports/SPsBankTransferReport",
         name: "SPsBankTransferReport",
         slug: "SPsBankTransferReport",
         show: true,
         i18n: "SPsBankTransferReport"
       },
      ]
  },
  {
    url: "/Employee",
    name: "Employee",
    slug: "Employee",
    icon: "PrinterIcon",
    show: true,
    i18n: "UserRole",
    submenu: [
      {
       url:"/Employee/Employee",
        name: "Employee",
        slug: "Employee",
        show: JSON.parse(localStorage.getItem("userInfo")).UserType == "SuperAdmin"||checkPermission("UserRole"),

        i18n: "UserRole"
      },
     
      ]
  },
];


